"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeEnv = exports.isTableCapacityTooLow = exports.isTableCapacityTooHigh = exports.isTableCapacitySuitable = void 0;
__exportStar(require("./dataTransferObject"), exports);
__exportStar(require("./events/index"), exports);
var isTableCapacitySuitable_1 = require("./isTableCapacitySuitable");
Object.defineProperty(exports, "isTableCapacitySuitable", { enumerable: true, get: function () { return isTableCapacitySuitable_1.isTableCapacitySuitable; } });
Object.defineProperty(exports, "isTableCapacityTooHigh", { enumerable: true, get: function () { return isTableCapacitySuitable_1.isTableCapacityTooHigh; } });
Object.defineProperty(exports, "isTableCapacityTooLow", { enumerable: true, get: function () { return isTableCapacitySuitable_1.isTableCapacityTooLow; } });
var NodeEnv_1 = require("./NodeEnv");
Object.defineProperty(exports, "NodeEnv", { enumerable: true, get: function () { return NodeEnv_1.NodeEnv; } });
//# sourceMappingURL=index.js.map